import { observer } from 'mobx-react-lite';
import { View } from 'react-native';
import { useStore } from '../../../../contexts/StoreContext';
import { Illustration } from '../../../illustration/Illustration';
import { ILLUSTRATION_NAMES } from '../../../illustration/illustration.helper';
import { TestIDs } from 'src/constants/testIDs.constants';
import BaseModal from '../../base-modal/BaseModal';
import { DynamicModalProps } from '../DynamicModal.types';
import { SELECTED_MENU_ITEMS } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';

export const ModalDeleteFromDrawer = observer(({ type, dynamicModalVisible, dynamicModalLayer: { id } }: DynamicModalProps) => {
  const {
    project,
    i18n,
    dynamicModal: { closeModal, activeModal },
  } = useStore();

  const onPressConfirmButton = async () => {
    activeModal.thumbnailsToDelete && project.activeProject?.deleteImages(activeModal.thumbnailsToDelete);
    project.activeProject?.thumbnailImages.length === 1 && activeModal?.setSelectedItem(SELECTED_MENU_ITEMS.Computer);
    closeModal();
  };

  const onReviewPressButton = async () => {
    closeModal();
  };

  return (
    <BaseModal
      testID={TestIDs.DELETE}
      modalIcon={
        <View style={{ width: 100, height: 100 }}>
          <Illustration name={ILLUSTRATION_NAMES.Delete} />
        </View>
      }
      title={i18n.t('modal-delete-from-drawer:title')}
      description={i18n.t('modal-delete-from-drawer:description')}
      discardText={i18n.t('modal-delete-from-drawer:abort')}
      confirmText={i18n.t('modal-delete-from-drawer:confirm')}
      handleDiscard={onReviewPressButton}
      handleConfirm={onPressConfirmButton}
      onClose={closeModal}
      onCloseOutside={closeModal}
      isVisible={dynamicModalVisible}
      type={type}
      id={id}
    />
  );
});
